import attrIsTruthy from '../../../../Common/js/util/attributeHelper';

const dl = window.dataLayer || [];

const analytics = {
  //push the event object to Google Tag Manager datalayer and logs using logEventObject
  pushToDataLayer(obj) {
    this.logEventObject(obj);
    dl.push(obj);
  },
  //This method logs the event object to the console only in a non-rod environment.
  logEventObject(obj) {
    if (!window.isNonProd) return;

    console.log('----------------------------- \n' + 'DataLayer Event Triggered: \n');
    console.log(obj);
    console.log('----------------------------- \n');
  },
  //Convert Query string to an Array of Objects.
  queryToObjFormat(queryStr, isObjFormat) {
    const resultArr = [];
    const queryArr = queryStr.split(';');
    const queryArrLength = queryArr.length;
    for (let i = 0; i < queryArrLength; i++) {
      const pipeArr = queryArr[i].split('&');
      const resultObj = {};
      for (let j = 0, len = pipeArr.length; j < len; j++) {
        const propValArr = pipeArr[j].split('=');
        if (propValArr != null && propValArr[0] != null && propValArr[1] != null) {
          resultObj[propValArr[0].toString()] = propValArr[1].toString() || '';
        }
      }
      resultArr.push(resultObj);
    }
    return queryArrLength === 1 && isObjFormat ? resultArr[0] : resultArr;
  },
  //Extracts information from the page data attributes, formats and pushes to the data layer
  trackDataLayerPageEvent: function trackDataLayerPageEvent() {
    const $bodyEl = $('body');
    let dataItems = {};
    const pageInfoObj = this.queryToObjFormat($bodyEl.data('ga-page-config'), true) || {};
    dataItems = { event: pageInfoObj.eventName };
    delete pageInfoObj.eventName;
    if (!pageInfoObj.pageCategory) {
      pageInfoObj.pageCategory = $bodyEl.data('ga-page-name') || '';
    }
    if (!pageInfoObj.pageSubCategory) {
      let pageSubCategory = $bodyEl.data('ga-page-subcategory');
      if (!pageSubCategory || pageSubCategory.length < 1 || pageSubCategory === ' ') {
        const wildcardPageCategory = $('#trackingPageCategory');
        if (wildcardPageCategory) {
          pageSubCategory = wildcardPageCategory.val();
        }
      }
      pageInfoObj.pageSubCategory = pageSubCategory || '';
    }
    dataItems.page = pageInfoObj;
    this.pushToDataLayer(dataItems);
  },
  async trackDataLayerBtnEvent($triggerBtnEl) {
    // Here for every next and button click in guided search, this triggers.
    const searchForm = $triggerBtnEl.closest('.search-listing--form');
    if (searchForm) {
      const searchFilterString = searchForm.find('#filterSelections');
      const searchFilterArray = new URLSearchParams(searchFilterString.val());
      let searchFilterFormatted = '';

      for (let p of searchFilterArray.values()) {
        searchFilterFormatted += p + ',';
      }

      if (searchFilterString) {
        const gaConfig = $triggerBtnEl.data('ga-config');
        // Take the input value and convert it to an array.
        // build a new array that is just values and comma delimited.
        $triggerBtnEl.data('ga-config', gaConfig + '&searchFilter=' + searchFilterFormatted);
      }
    }
    // for each individual button click event within the purchase form we fire this event and populate the Data Layer with the latest information based on user interactions
    const configObj = this.queryToObjFormat($triggerBtnEl.data('ga-config'), true);
    const dataItems = { event: configObj.eventName };
    delete configObj.eventName;
    switch (dataItems.event) {
      case 'trackButtonClick':
        if (!configObj.buttonGroup) {
          configObj.buttonGroup = $bodyEl.data('ga-page-name') || '';
        }
        dataItems.eventContext = configObj;
        this.pushToDataLayer(dataItems);
        break;
      case 'trackValidForm':
        if ($triggerBtnEl.closest('form').valid()) {
          if (!configObj.buttonGroup) {
            configObj.buttonGroup = $bodyEl.data('ga-page-name') || '';
          }
          dataItems.eventContext = configObj;
          this.pushToDataLayer(dataItems);
        }
        break;
      default:
        break;
    }
  },
  init() {
    this.trackDataLayerPageEvent();
    $(document)
      .find('[data-btn-ga-enabled]')
      .on('click', (evt) => {
        const $btnEl = $(evt.currentTarget);
        if ($btnEl.length && attrIsTruthy($btnEl.data('btn-ga-enabled')) && $btnEl.data('ga-config')) {
          this.trackDataLayerBtnEvent($btnEl);
        }
      });
  },
};

$(() => {
  const $bodyEl = $('body');
  if (attrIsTruthy($bodyEl.data('ga-normal-editor')) && attrIsTruthy($bodyEl.data('ga-page-enabled'))) {
    analytics.init();
  }
});

export default analytics;
